// Actions
export const REQUIRED_SERVICES__GET_REQUIRED_SERVICE = 'REQUIRED_SERVICES__GET_REQUIRED_SERVICE';
export const REQUIRED_SERVICES__REJECT_QUOTE = 'REQUIRED_SERVICES__REJECT_QUOTE';
export const REQUIRED_SERVICES__APPROVE_QUOTE = 'REQUIRED_SERVICES__APPROVE_QUOTE';
// Getters
export const REQUIRED_SERVICES__GROUPED_BY_PROPERTY = 'REQUIRED_SERVICES__GROUPED_BY_PROPERTY';
// Mutations
export const REQUIRED_SERVICES__RESET = 'REQUIRED_SERVICES__RESET';
export const REQUIRED_SERVICES__MUTATE_REQUIRED_SERVICES =
  'REQUIRED_SERVICES__MUTATE_REQUIRED_SERVICES';
export const REQUIRED_SERVICES__MUTATE_REQUIRED_SERVICE =
  'REQUIRED_SERVICES__MUTATE_REQUIRED_SERVICE';
export const REQUIRED_SERVICES__MUTATE_LOADING_STATUS = 'REQUIRED_SERVICES__MUTATE_LOADING_STATUS';
